import { useState, useRef } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { useWindowSize } from "react-use";
import { ControlledMenu, useClick, MenuButton } from "@szhsin/react-menu";

import cn from "@utils/cn";
import buttonCn from "@utils/buttonCn";
import Icon from "@elements/Icon";
import ActionMenuItem from "@components/action_menu/ActionMenuItem";

const MOBILE_BREAKPOINT = 769;

const MENU_CLASS_NAMES = cn(`
  z-50
  min-w-96
  box-border
  text-sm
  rounded-xl
  border
  overflow-hidden
  select-none

  bg-white
  border-gallery-300
  shadow-lg
  shadow-black/10

  focus:outline-hidden
`);

export default function ActionMenu(props) {
  const {
    items,
    hotkeys = [],
    menuClassName: menuClassNameOverride,
    portal = false,
  } = props;

  const [isOpen, setOpen] = useState(false);

  const toggle = () => setOpen((prevValue) => !prevValue);

  const anchorRef = useRef(null);
  const anchorProps = useClick(isOpen, setOpen);

  const { width } = useWindowSize();

  const handleClose = () => setOpen(false);

  /**************************************************************************************************/

  useHotkeys(hotkeys, toggle, {
    enabled: hotkeys.length > 0,
    enableOnFormTags: false,
    enableOnContentEditable: false,
    preventDefault: true,
  }, [toggle]);

  /**************************************************************************************************/

  const buttonClassNames = buttonCn({
    className: {
      "bg-gallery-200": isOpen,
      "border-gallery-400": isOpen,
    },
    isIconOnly: true,
  });

  const menuClassNames = cn(MENU_CLASS_NAMES, menuClassNameOverride, {
    "animate-fade-in-down": isOpen,
    "animate-fade-out-up": !isOpen,
  });

  return (
    <div>
      <MenuButton
        className={buttonClassNames}
        ref={anchorRef}
        {...anchorProps}
      >
        <Icon iconName="ellipsis" />
      </MenuButton>

      <ControlledMenu
        anchorRef={anchorRef}
        state={isOpen ? "open" : "closed"}
        transition={true}
        align={width < MOBILE_BREAKPOINT ? "center" : "end"}
        position="anchor"
        direction="bottom"
        gap={4}
        portal={portal || undefined}
        onClose={handleClose}
        menuClassName={menuClassNames}
      >
        {items?.map((item, index) => (
          <ActionMenuItem
            key={index}
            {...item}
          />
        ))}
      </ControlledMenu>
    </div>
  );
}
